import React, { useEffect, useMemo } from 'react';

import { defineMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from '@nhl/nhl-breakaway-ui';

import { filterActionCreators } from '~/redux/ducks/playersAndTeams/filter';

const DraftRoundSelect = () => {
    const dispatch = useDispatch();
    const intl = useIntl();

    const draftData = useSelector((state) => state.config.draftData);
    const selectedDraftYear = useSelector((state) => state.playersAndTeams.filter.values.draftYear);
    const selectedRound = useSelector((state) => state.playersAndTeams.filter.values.draftRound);

    /*
        We will select all draftYears for either the selectedDraftYear or the current season range
        We will pass in these years and get the different rounds available
     */
    const draftRounds = useMemo(() => {
        const draftYears = selectedDraftYear ? [selectedDraftYear] : draftData.map((draft) => draft.draftYear);
        const allRounds = draftData.filter((draft) => draftYears.includes(draft.draftYear)).map((d) => d.rounds);
        const maxRound = Math.max(...allRounds);

        const rounds = [
            {
                key: '',
                value: '',
                label: intl.formatMessage(
                    defineMessage({
                        defaultMessage: 'All Draft Rounds',
                        description: 'A phrase describing an option that will include all draft rounds when selected',
                    }),
                ),
            },
        ];
        for (let i = 1; i <= maxRound; i += 1) {
            rounds.push({ key: i, value: i, label: `${i}` });
        }
        return rounds;
    }, [selectedDraftYear, draftData]);

    const setDraftRound = (e, { value }) => {
        dispatch(filterActionCreators.setDraftRound(value));
    };

    useEffect(() => {
        if (draftRounds.findIndex((round) => round.key === selectedRound) === -1) {
            setDraftRound(undefined, { value: '' });
        }
    }, [draftRounds, selectedRound]);

    const selectedOption = useMemo(
        () => draftRounds.find((obj) => obj.value === selectedRound) || draftRounds[0],
        [draftRounds, selectedRound],
    );
    const disabled = selectedDraftYear === 'undrafted' || draftRounds.length === 1;

    return (
        <Select
            isSelectDisabled={disabled}
            onOptionChange={setDraftRound}
            options={draftRounds}
            selectedOption={selectedOption}
            isSearchEnabled
            optionsBoxAriaLabel=""
            dropdownButtonAriaLabel=""
        />
    );
};

export default React.memo(DraftRoundSelect);
